import Tasks from 'APP/Tasks';
import { UpdateReason } from 'APP/constants/scroll';
import { IUpdateScheduledMessageEventPayloadResponse } from 'APP/model/counter/counterModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class ScheduledMessageWasUpdated extends GroupsEvent<IUpdateScheduledMessageEventPayloadResponse> {
  async process(): Promise<void> {
    const { groupId, messageId } = this.eventPayload!;

    const group = Entities.GroupsStore.getGroupById(groupId.toString());
    if (!group) {
      return;
    }

    try {
      const message = await messageModel.getScheduledMessage(group.id, messageId.toString());
      if (!message) {
        return;
      }

      Tasks.messaging.updateScheduledMessages(group.id, [message]);

      if (group.isActive) {
        Entities.ChatStore.setScrollChanged(UpdateReason.EditMessage, {
          messageIds: [message.id],
          isAnimated: true,
        });
      }
    } catch (error) {
      if (!error?.code || error.code !== 400) {
        console.error(error);
      }
    }
  }
}
